module.exports = __webpack_public_path__ + "static/media/18-mobile.b3ca8ad9.jpg";